// src/setup.js - CON PROJECT ID CORRECTO
// CONFIGURACIÓN DE PRODUCCIÓN
window.REACT_APP_APPKIT_PROJECT_ID = "df139799df85ef65e80aa73d82a14195"; // ⭐⭐ ESTE ES TU ID REAL
window.REACT_APP_STRIPE_PUBLISHABLE_KEY = "pk_live_51SnbMtIdXPEw0oD6BDl2DdzSgjq9fRDdda4VoHBfWLtmQxWBjLWMc2IQtQkPZMtdq1izGE6LvHiZ2KAHzE9haAzo002yRb7m9W";
window.REACT_APP_BACKEND_URL = "https://reanimeitor.com/backend";

console.log('✅ Configuración de producción cargada');
console.log('AppKit ID:', window.REACT_APP_APPKIT_PROJECT_ID);